/** Turning the corpus's values into something a person would say.
 *
 * Its own module rather than living beside the components: a file that
 * exports both components and plain functions loses fast refresh, so every
 * edit to a helper reloads the whole app and drops the state you were
 * looking at.
 */

/** A date as a person would say it.
 *
 * Parsed at local midnight rather than as a bare ISO date, which Date reads
 * as UTC -- so west of Greenwich "2026-07-12" renders as the 11th, and the
 * date on the page disagrees with the one in the law.
 */
export function when(iso: string | null): string {
  if (!iso) return "";
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
